import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BadgeModule } from 'primeng/badge';
import { PrimengButtonDirective } from '../../../button/directives/primeng-button.directive';
import { Icon } from '../../../icon/enums/icon';
import { IconComponent } from '../../../icon/components/icon/icon.component';
import { ToStringPipe } from '../../../text/pipes/to-string.pipe';
import { isNotNil } from '@web/utils';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-notification-bell',
  imports: [
    ButtonModule,
    PrimengButtonDirective,
    IconComponent,
    BadgeModule,
    ToStringPipe,
  ],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationBellComponent {
  @Input() public count!: number;

  protected readonly Icon = Icon;
  protected readonly isNotNil = isNotNil;
}
